import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "../../lib/content";
import { useLang } from "../../lib/i18n";

export const FloatingCta = ({ contact }) => {
  const [show, setShow] = useState(false);
  const { t, lang } = useLang();
  useEffect(() => {
    const onScroll = () => setShow(window.innerWidth < 640 || window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.a initial={{ y: 80, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 80, opacity: 0 }}
          href={waLink(contact, "", lang)} target="_blank" rel="noreferrer" data-testid="floating-whatsapp-btn"
          className="fixed bottom-4 start-4 end-4 z-40 flex items-center justify-center gap-2 rounded-full bg-accent py-3.5 font-bold text-onaccent shadow-[0_10px_40px_rgb(var(--accent-rgb)/0.3)] sm:start-auto sm:end-6 sm:bottom-6 sm:px-6">
          <MessageCircle size={18} /> {t.bookTrial}
        </motion.a>
      )}
    </AnimatePresence>
  );
};
